<template>
  <div>
    <b-modal id="modal-edit-hirarki" size="lg" centered title="Edit Data Master Hirarki" header-bg-variant="warning" header-text-variant="light" @keydown.enter.prevent="simpan()">
      <b-form>
        <b-form-group label="Posisi Atasan" label-cols-md="3">
          <Multiselect
            :state="checkIfValid('atasan')"
            v-model="$v.dataEdit.atasan.$model"
            :options="posisi"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            track-by="masterPosisiId"
            label="namaPosisi"
            placeholder="-- Pilih Posisi Atasan --"
          ></Multiselect>
        </b-form-group>

        <b-form-group label="Posisi Bawahan" label-cols-md="3">
          <Multiselect
            :state="checkIfValid('bawahan')"
            v-model="$v.dataEdit.bawahan.$model"
            :options="posisi"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            track-by="masterPosisiId"
            label="namaPosisi"
            placeholder="-- Pilih Posisi Bawahan --"
          ></Multiselect>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-edit-hirarki')"> Tutup </b-button>
        <b-button variant="primary" :disabled="busy || !isValid" @click="simpan()">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "modalEditHirarki",
  props: ["posisi", "edit", "data"],
  data() {
    return {
      dataEdit: {
        atasan: null,
        bawahan: null,
      },
      busy: false,
      button: "Simpan",
    };
  },
  mixins: [validationMixin],
  validations: {
    dataEdit: {
      atasan: { required },
      bawahan: { required },
    },
  },
  computed: {
    isValid() {
      return !this.$v.dataEdit.$invalid;
    },
    isDirty() {
      return this.$v.dataEdit.$anyDirty;
    },
  },
  watch: {
    edit(newVal, oldVal) {
      if (newVal !== oldVal) {
        const vm = this;
        const atasan = vm.posisi.find((pos) => pos.masterPosisiId === vm.data.atasan);
        const bawahan = vm.posisi.find((pos) => pos.masterPosisiId === vm.data.bawahan);

        vm.dataEdit.atasan = atasan || null;
        vm.dataEdit.bawahan = bawahan || null;
      }
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.dataEdit[fieldName];
      if (!field.$dirty) return null;
      return !field.$invalid && field.$model !== "";
    },

    simpan() {
      const vm = this;
      vm.busy = true;
      vm.button = "Mohon Tunggu"
      const payload = {
        id: vm.data.id, 
        atasan: vm.dataEdit.atasan.masterPosisiId,
        bawahan: vm.dataEdit.bawahan.masterPosisiId,
      };

      vm.$axios
        .post("levelAgreement/update", payload)
        .then((res) => {
          vm.button = "Simpan";
          vm.busy = false;

          if (res.data.message === "sukses") {
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENGUBAH MASTER HIRARKI POSISI",
              showing: true,
            });
            vm.$bvModal.hide("modal-edit-hirarki");
          } else {
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch(() => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
